import { render } from "./CaseList.vue?vue&type=template&id=d6d679e0&scoped=true"
import script from "./CaseList.vue?vue&type=script&lang=ts"
export * from "./CaseList.vue?vue&type=script&lang=ts"

import "./CaseList.vue?vue&type=style&index=0&id=d6d679e0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d6d679e0"

export default script